import Modal from "../../utils/modal";
import Button from "../../atoms/button";
import { BLOCK_REASON_LABELS } from "./extendedCards";

/**
 * Estendidos que não podem ser impressos agora (spec §5.4): arte não aprovada,
 * flag desligada ou gerador mobile. Nunca caem no papel padrão.
 */
const ExtendedArtBlockModal = ({ blocked, remainingCount, onReview, onQueue, onContinue, onCancel }) => (
  <Modal width="min(96%, 720px)">
    <div role="dialog" aria-label="Seriais de arte estendida bloqueados" className="p-2 text-left text-orange-100">
      <h2 className="mb-2 text-lg font-semibold text-[#d59106]">Arte estendida bloqueada</h2>
      <p className="mb-3 text-sm text-orange-100/70">
        Estes seriais não podem ser impressos agora. Seriais de arte estendida nunca saem no papel padrão.
      </p>
      <table className="mb-3 w-full text-sm">
        <thead className="text-[#d59106]">
          <tr>
            <th scope="col" className="text-left">Serial</th>
            <th scope="col" className="text-left">Modelo</th>
            <th scope="col" className="text-left">Motivo</th>
            <th scope="col"><span className="sr-only">Ações</span></th>
          </tr>
        </thead>
        <tbody>
          {blocked.map((item) => (
            <tr key={item.serialNumber} className="border-b border-[#d59106]/20">
              <td className="font-mono">{item.serialNumber}</td>
              <td>{item.modelName}</td>
              <td>{BLOCK_REASON_LABELS[item.reason] || item.reason}</td>
              <td className="text-right">
                {item.artKey ? (
                  <button type="button" className="text-[#d59106] underline" onClick={() => onReview(item.artKey)}>Abrir revisão</button>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex flex-wrap gap-2">
        <Button classes="bg-[#1a1a1a] text-orange-100 border border-[#d59106]/40 px-4" click={onQueue}>Ver fila de artes</Button>
        <Button classes="bg-green-400 hover:bg-green-300 px-4" click={onContinue} disabled={remainingCount === 0}>{`Gerar só os demais (${remainingCount})`}</Button>
        <Button classes="bg-red-300 hover:bg-red-400 px-4" click={onCancel}>Cancelar</Button>
      </div>
    </div>
  </Modal>
);

export default ExtendedArtBlockModal;
